module.exports = __webpack_public_path__ + "assets/img/tenthThree.48b51c23.jpg";